// components/modals/FailureModal.js
import React from 'react';
import Modal from "react-bootstrap/Modal";

const FailureModal = ({ show, onClose }) => {
    return (
        <Modal className="success" show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Failed</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="innercontentmodal">
                    <div className="upperheading">
                        <img src="/assets/failed.svg" alt="" />
                        <h2>Transaction Failed</h2>
                        <p>
                            Your stake could not be completed. Please try again or check
                            your wallet for details.
                        </p>
                    </div>
                </div>

                <div className="lastbutton">
                    <button className="closemain" onClick={onClose}>Close</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default FailureModal;